module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/lost-cf2e1a2019cf9afa3dd874254a6e05e7.jpg";